// guards/RoleGuard.js
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import useLocales from 'hooks/useLocales';

import useAuthorityAll from 'hooks/useAuthorityAll';

export default function RoleGuard({
  ctrl,
  role,
  rolestring,
  children
}: {
  ctrl: string;
  role: any[];
  rolestring: string;
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { trans: t } = useLocales();

  const { enqueueSnackbar } = useSnackbar();

  // const permissions = useSelector((state: any) => state?.user?.permissions || []);

  const permission = useAuthorityAll({
    ctrl,
    role
  });

  useEffect(() => {
    // if (!permission?.rolestring) return; // 不需要权限的直接看
    if (!permission[rolestring]) {
      enqueueSnackbar(t('PermissionSetting.no_Permission'), { variant: 'error' });
      // 没有权限
      if (window.history.length > 1) {
        navigate(-1); // 回上一页
      } else {
        navigate('/dashboard/app'); // 没历史栈，回默认主页
      }
    }
  }, [permission, navigate, location]);

  return <>{children}</>;
}
